import { gql } from "~/__generated__"

export const ROBIN_MARKETING_URL = "https://tryrobin.app"
export const ROBIN_DASHBOARD_URL = "https://tryrobin.app/dashboard"

// Robin's dashboard prefills its "Roster ID" field from the agency slug in the
// public Zano roster URL (/agency-roster/:slug), so we pass the slug alone as
// roster_id — matching the field Robin echoes back on the confirmation webhook.
export const robinConnectUrl = (rosterSlug: string) =>
  `${ROBIN_DASHBOARD_URL}?roster_id=${encodeURIComponent(rosterSlug)}`

export const ROBIN_CONNECT_MUTATION = gql(`
  mutation RobinConnect($input: RobinConnectInput!) {
    robinConnect(input: $input) {
      agency {
        id
        robinConnected
        robinConnectPending
      }
    }
  }
`)
